<template>
  <v-card v-if="$page.props.title" flat>
    <v-card-text>
      <v-card-text>
        <h2 class="title">
          {{ $page.props.title }}
        </h2>
      </v-card-text>
      <v-divider v-if="$page.props.tabs" />
      <v-tabs v-if="$page.props.tabs" v-model="active">
        <v-tab v-for="tab in $page.props.tabs" :key="tab.label" @click="click(tab)">
          {{ tab.label }}
        </v-tab>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
   data: () => ({
      active: null
   }),
   mounted () {
      for (const key in this.$page.props.tabs) {
         if (!this.$page.props.tabs[key].route) {
            this.active = parseInt(key)
            return
         }
      }
   },
   methods: {
      click (tab) {
         this.$inertia.visit(this.route(tab.route))
      }
   }
}
</script>
